module.exports = __webpack_public_path__ + "media/images/iconPlus-668dca97314e12a78c98b1982e7ecea8.png";